export enum PkgType {
    count = 1,
    vipTime = 2,
}

export enum PayType {
    pay = 1,
    unpaid = 2,
}

export const DURANTION_FOREVER = -1;

export type DurationUnit = "day" | "month" | "year";

export enum PkgStatus {
    unactived = 1,
    actived = 2,
}

export type IPayPackage = {
    /**
     * 支付套餐表
     */
    id: number;
    /**
     * 套餐类型（二进制状态码），1：纠错次数套餐，2：vip时长套餐
     */
    type: PkgType;
    /**
     * 支付类型，1：需要支付（需要支付fee列的费用）；2：非支付（指到达一定条件送的优惠，比如邀请一定数量好友）
     */
    pay_type: PayType;
    /**
     * 套餐名字
     */
    name: string;
    /**
     * 简单描述套餐
     */
    description: string;
    /**
     * 费用，单位分(人民币)
     */
    fee: number;
    /**
     * 纠错次数
     */
    count?: number;
    /**
     * 分销收益（邀请的用户购买支付套餐时购买此套餐的用户得到的收益百分比）
     */
    profit_percent: number;
    /**
     * 用于vip时长套餐，vip时长，单位为duration_unit列的值，-1为永久,
     */
    duration?: number;
    /**
     * 用于vip时长套餐，vip时长单位，只能是day，month或year
     */
    duration_unit?: DurationUnit;
    /**
     * 套餐状态，0:未激活 1:激活
     */
    status: PkgStatus;
    /**
     * 创建时间
     */
    created_at: number;
    /**
     * 更新时间
     */
    updated_at: number;
};

export class PayPackage implements IPayPackage {
    /**
     * 支付套餐表
     */
    id!: number;
    /**
     * 套餐类型（二进制状态码），1：纠错次数套餐，2：vip时长套餐
     */
    type!: PkgType;
    /**
     * 支付类型，1：需要支付（需要支付fee列的费用）；2：非支付（指到达一定条件送的优惠，比如邀请一定数量好友）
     */
    pay_type!: PayType;
    /**
     * 套餐名字
     */
    name!: string;
    /**
     * 简单描述套餐
     */
    description!: string;
    /**
     * 费用，单位分(人民币)
     */
    fee!: number;
    /**
     * 纠错次数
     */
    count?: number;
    /**
     * 分销收益（邀请的用户购买支付套餐时购买此套餐的用户得到的收益百分比）
     */
    profit_percent!: number;
    /**
     * 用于vip时长套餐，vip时长，单位为duration_unit列的值，-1为永久,
     */
    duration?: number;
    /**
     * 用于vip时长套餐，vip时长单位，只能是day，month或year
     */
    duration_unit?: DurationUnit;
    /**
     * 套餐状态，0:未激活 1:激活
     */
    status!: PkgStatus;
    /**
     * 创建时间
     */
    created_at!: number;
    /**
     * 更新时间
     */
    updated_at!: number;

    constructor(payPkg?: IPayPackage) {
        if (payPkg) Object.assign(this, payPkg);
    }

    get durationText(): string {
        if (!this.duration) return "";
        if (this.duration === DURANTION_FOREVER) return "永久";
        switch (this.duration_unit) {
            case "day":
                return this.duration + "天";
            case "month":
                return this.duration + "个月";
            case "year":
                return this.duration + "年";
        }
        return "";
    }
}
